module.exports = __webpack_public_path__ + "media/images/country_flags/tg-dbd93358e1f33473e228615e159b1424.png";